import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Ruler } from "lucide-react";

interface IChimneySize {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ChimneySize(props: IChimneySize) {
    const { value, onChange, loading } = { ...props };
    const [chimneySize, setChimneySize] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setChimneySize(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setChimneySize(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Chimney Size
            </Typography>

            <Select
                placeholder="Select chimney size"
                value={chimneySize}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Ruler size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="None">None</Option>
                <Option value="Small (24x24)">Small (24"×24")</Option>
                <Option value="Average (32x36)">Average (32"×36")</Option>
                <Option value="Large (32x60)">Large (32"×60")</Option>
            </Select>
        </Box>
    );
}
